import { v4 as uuidv4 } from 'uuid';

export function MinicartSummary(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'MinicartSummary',
		componentId: uuidv4(),
		props,
		childrenComponents,
		blocks,
	};
}
